import { render, staticRenderFns } from "./contrato.vue?vue&type=template&id=0c9e97c4&lang=html"
import script from "./contrato.vue?vue&type=script&lang=js"
export * from "./contrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports